<template>
  <div class="alert alert-secondary">
    <div class="pt-2 mb-2">
      <div class="d-flex">
        <img class="border border-secondary rounded mr-2" :src="authorPic" width="75" height="75">
        <div class="commentContent">
          <ul class="list-inline pb-1 mb-0">
            <li class="list-inline-item text-black-50"><small><i class="fas fa-user fa-fw"></i>
              <router-link :to="'/thinktank-user/' + authorSlug">{{author}}</router-link></small>
            </li>
            <li class="list-inline-item text-black-50"><small><i class="fas fa-clock fa-fw"></i> {{date.substring(0, 10)}}</small></li>
          </ul>
          <div v-html="content" class="commentText mb-0"></div>
          <button v-if="!showPost" type="button" class="btn btn-link p-0" v-on:click="makeComment(parentCommentId)">Reply</button>
          <button v-if="showPost" type="button" class="btn btn-link p-0" v-on:click="loadIdea()">{{showHideState}} idea</button>
        </div>
        <img :src="country" class="countryFlag" width="50" height="33">
      </div>
    </div>
    <div v-if="showIdea" class="linked-idea">
      <span v-if="idea === 'Loading idea...'">{{idea}}</span>
      <transition name="grow">
        <Ideas v-if="idea !== 'Loading idea...'" :ideas="idea"></Ideas>
      </transition>
    </div>
    <div v-if="replies.length > 0" v-for="reply in replies" v-bind:key="reply.id" class="alert alert-light">
      <div class="pt-2">
        <div class="d-flex">
          <img class="border border-secondary rounded mr-2" :src="authorPic" width="75" height="75">
          <div class="commentContent">
            <ul class="list-inline pb-1 mb-0">
              <li class="list-inline-item text-black-50"><small><i class="fas fa-user fa-fw"></i>
                <router-link :to="'/thinktank-user/' + reply.author">{{reply.author_name}}</router-link> replied to:
                <router-link :to="'/thinktank-user/' + authorSlug">{{author}}</router-link></small>
              </li>
              <li class="list-inline-item text-black-50"><small><i class="fas fa-clock fa-fw"></i> {{reply.date.substring(0, 10)}}</small></li>
            </ul>
            <div v-html="reply.content.rendered" class="mb-0"></div>
            <button v-if="!showPost" type="button" class="btn btn-link p-0" v-on:click="makeComment(parentCommentId)">Reply</button>
          </div>
          <img class="float-right" :src="country" width="50" height="33">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import Ideas from '@/components/Ideas'
export default {
  props: [
    'parentCommentId',
    'author',
    'authorSlug',
    'date',
    'content',
    'country',
    'authorPic',
    'replies',
    'postId',
    'showPost',
    'textBoxReference'
  ],
  components: {
    Ideas
  },
  methods: {
    makeComment: function (commentID) {
      document.getElementById(this.textBoxReference).focus()
      this.$emit('setCommentParent', commentID)
    },
    loadIdea: function () {
      this.showIdea = !this.showIdea
      if (this.showIdea && this.idea === 'Loading idea...') {
        WordpressRestAPI.getViewContent('idea/' + this.postId + '?_embed')
          .then(response => {
            this.idea = []
            this.idea[0] = response.data
          })
          .catch(e => {
            this.ContentLoadError = 'Oops! We had a problem with loading this idea. Please try again later.'
            console.error(e)
          })
      }
    }
  },
  computed: {
    showHideState: function () {
      if (this.showIdea) {
        return 'Hide'
      } else {
        return 'View'
      }
    }
  },
  data () {
    return {
      idea: 'Loading idea...',
      showIdea: false,
      ContentLoadError: ''
    }
  }
}
</script>

<style lang="less">
  .commentContent {
    width: calc(~"100% - 125px");
    .commentText {
      p {
        margin-bottom: 0
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue